import React, {useState, useEffect} from 'react';
import {SliderController} from "../slider-controller";
import {SliderProps} from "./slider";

export const SliderComposer = (Slider) => ((props: SliderProps) => {
  const [controller] = useState(new SliderController());

  useEffect(() => {
    const total = controller.slides?.map((item) => item?.getBoundingClientRect().width).sum();

    controller.totalSlidesWidth = total;
  }, [props.items]);

  useEffect(() => {
    const position = props.initialIndex * controller.getSlideWidth(props.initialIndex);
    controller.update(props.initialIndex, position);
  }, [props.initialIndex, props.items?.length, props.selectedItem]);

  const children = React.Children.toArray(props.children);
  const direction = props.isRtl ? 'right' : 'left';

  const moveItemOnClick = (index) => {
    if(props.shouldMoveItemsOnClick) {
      const position = index * controller.getSlideWidth(index);
      controller.update(index, position);
    }
  }


  return <Slider {...props} controller={controller} children={children} direction={direction} moveItemOnClick={(index) => moveItemOnClick(index)}/>;
});

